import Axios from "axios";
import {
    SET_BANK_LIST,
    UNSET_BANK_LIST,
    SET_EDITING_BANK_LIST,
    UNSET_EDITING_BANK_LIST,
} from "@/store/mutation-types";
import { 
    getBankList, 
    getBankById,
    saveBank,
    updateBank,
} from "@/store/api";

// initial state
const state = {
    getBankList: [],
    getEditingBank: {},
};

const getters = {
    getBankList(state) {
        return state.getBankList;
    },
    getEditingBank(state) {
        return state.getEditingBank;
    },
};

const mutations = {
    [SET_BANK_LIST](state, data) {
        state.getBankList = data;
    },
    [UNSET_BANK_LIST](state) {
        state.getBankList = [];
    },
    [SET_EDITING_BANK_LIST](state, data) {
        state.getEditingBank = data;
    },
    [UNSET_EDITING_BANK_LIST](state) {
        state.getEditingBank = {};
    },
};

const actions = {
    saveBank({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(saveBank, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    updateBank({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.put(`${updateBank}/${data.bank_id}`, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getBankList({ commit }) {
        return new Promise((resolve, reject) => {
        Axios.get(getBankList)
            .then(function (response) {
            commit('SET_BANK_LIST', response.data.data);
            resolve(response);
            })
            .catch(function (error) {
            commit('UNSET_BANK_LIST');
            reject(error);
            });
        });
    },

    getBankById({ commit }, data) {
        const getBankRecordById = `${getBankById}/${data}`;
            commit("SET_LOADING", { color: "primary" });
            return new Promise((resolve, reject) => {
                Axios.get(getBankRecordById)
                    .then((response) => {
                    resolve(response.data); 
                })
                    .catch((error) => {
                    console.error("API Error:", error.response?.data || error.message);
                    reject(error);
                })
                    .finally(() => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

